(() => {
  var SWATCH_SELECTOR = '[data-product-card-swatch]';

  function getLabel(card) {
    return card.querySelector('[data-product-card-swatch-label]');
  }

  function showLabel(card, value) {
    var label = getLabel(card);
    if (label && value) label.textContent = value;
  }

  function restoreSelectedLabel(card) {
    var label = getLabel(card);
    if (label) label.textContent = label.getAttribute('data-selected-value') || '';
  }

  function updateProductLinks(card, color) {
    var links = card.querySelectorAll('.product-item__image-link, .product-item__product-title a');

    links.forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('color', color);
        link.href = url.toString();
      } catch (error) {}
    });
  }

  function setImageSource(image, src) {
    if (!image || !src) return;

    image.classList.add('product-card__image--changing');

    var finish = function () {
      image.classList.remove('product-card__image--changing');
    };

    image.addEventListener('load', finish, { once: true });
    image.setAttribute('src', src);
    image.setAttribute('srcset', src);

    if (image.hasAttribute('data-src')) image.setAttribute('data-src', src);
    if (image.hasAttribute('data-srcset')) image.setAttribute('data-srcset', src);

    if (image.complete) window.setTimeout(finish, 60);
  }

  function updateCardImages(card, swatch) {
    var primarySrc = swatch.getAttribute('data-image-src');
    var secondarySrc = swatch.getAttribute('data-second-image-src');

    var primary =
      card.querySelector('.product-item__image--one .image__img') ||
      card.querySelector('.product-item__image .image__img');

    var secondary = card.querySelector('.product-item__image--two .image__img');

    setImageSource(primary, primarySrc);
    if (secondary && secondarySrc) setImageSource(secondary, secondarySrc);

    var color = swatch.getAttribute('data-option-value');
    var titleNode = card.querySelector('.product-item__product-title');

    if (primary && color && titleNode) {
      primary.alt = titleNode.textContent.trim() + ' – ' + color;
    }
  }

  function selectCardSwatch(swatch) {
    var card = swatch.closest('.product-item');
    if (!card) return;

    card.querySelectorAll(SWATCH_SELECTOR).forEach(function (item) {
      item.setAttribute('aria-pressed', 'false');
      item.classList.remove('is-active');
    });

    swatch.setAttribute('aria-pressed', 'true');
    swatch.classList.add('is-active');

    var color = swatch.getAttribute('data-option-value');

    if (color) {
      var label = getLabel(card);
      if (label) {
        label.setAttribute('data-selected-value', color);
        label.textContent = color;
      }
      updateProductLinks(card, color);
    }

    updateCardImages(card, swatch);
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    selectCardSwatch(swatch);
  }, true);

  document.addEventListener('keydown', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectCardSwatch(swatch);
    }
  });

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (card) showLabel(card, swatch.getAttribute('data-option-value'));
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;
    if (event.relatedTarget && swatch.contains(event.relatedTarget)) return;

    var card = swatch.closest('.product-item');
    if (card) restoreSelectedLabel(card);
  });

  document.addEventListener('focusin', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (card) showLabel(card, swatch.getAttribute('data-option-value'));
  });

  document.addEventListener('focusout', function (event) {
    var swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (card) restoreSelectedLabel(card);
  });

  function applyRequestedProductColor() {
    if (!document.body.classList.contains('template-product')) return;

    var requestedColor = new URLSearchParams(window.location.search).get('color');
    if (!requestedColor) return;

    var attempts = 0;
    var maxAttempts = 30;

    function trySelect() {
      var buttons = document.querySelectorAll('[data-option-value]');
      var target = null;

      for (var i = 0; i < buttons.length; i += 1) {
        if (
          buttons[i].getAttribute('data-option-value') === requestedColor &&
          !buttons[i].matches(SWATCH_SELECTOR)
        ) {
          target = buttons[i];
          break;
        }
      }

      if (target) {
        if (
          !target.classList.contains('selected') &&
          target.getAttribute('aria-pressed') !== 'true'
        ) {
          target.click();
        }
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) window.setTimeout(trySelect, 100);
    }

    trySelect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRequestedProductColor, { once: true });
  } else {
    applyRequestedProductColor();
  }
})();
